import { call, put, takeEvery, all, fork } from 'redux-saga/effects';

import {
  GET_SCHEDULE,
  GET_SCHEDULE_BY_ID,
  CREATE_SCHEDULE,
  UPDATE_SCHEDULE,
  UPDATE_SCHEDULE_REALIZED,
  DELETE_SCHEDULE,
} from './actionType';

import { ScheduleApiResponseError, ScheduleApiResponseSuccess } from './action';

import {
  getSchedule as scheduleGet,
  getScheduleById as scheduleGetById,
  createSchedule as scheduleCreate,
  updateSchedule as scheduleUpdate,
  updateScheduleRealized as scheduleUpdateRealized,
  deleteSchedule as specialtyProviderDelete,
} from '../../helpers/backend_helper';
import { notifyError, notifySuccess } from '../../components/notify';

function* getSchedule({ payload }) {
  try {
    const response = yield call(scheduleGet, payload.id);
    yield put(ScheduleApiResponseSuccess(GET_SCHEDULE, response));
  } catch (error) {
    yield put(ScheduleApiResponseError(GET_SCHEDULE, error));
  }
}

function* getScheduleById({ payload }) {
  try {
    const response = yield call(scheduleGetById, payload.id);
    yield put(ScheduleApiResponseSuccess(GET_SCHEDULE_BY_ID, response));
  } catch (error) {
    yield put(ScheduleApiResponseError(GET_SCHEDULE_BY_ID, error));
  }
}

function* createSchedule({ payload }) {
  try {
    const response = yield call(scheduleCreate, payload.data);
    yield put(ScheduleApiResponseSuccess(CREATE_SCHEDULE, response));
    notifySuccess('Visita agendada com sucesso!');
  } catch (error) {
    yield put(ScheduleApiResponseError(CREATE_SCHEDULE, error));
    notifyError('Erro ao agendar visita');
  }
}

function* updateSchedule({ payload }) {
  try {
    const response = yield call(scheduleUpdate, {
      id: payload.id,
      data: payload.data,
    });
    yield put(ScheduleApiResponseSuccess(UPDATE_SCHEDULE, response));
    notifySuccess('Visita atualizada com sucesso!');
  } catch (error) {
    yield put(ScheduleApiResponseError(UPDATE_SCHEDULE, error));
    notifyError('Erro ao atualizar visita');
  }
}

function* updateScheduleRealized({ payload }) {
  try {
    const response = yield call(scheduleUpdateRealized, {
      id: payload.id,
      data: payload.data,
    });
    yield put(ScheduleApiResponseSuccess(UPDATE_SCHEDULE_REALIZED, response));
    notifySuccess('Marcado como realizado!');
  } catch (error) {
    yield put(ScheduleApiResponseError(UPDATE_SCHEDULE_REALIZED, error));
    notifyError('Erro ao marcar como realizado');
  }
}

function* deleteSchedule(data) {
  try {
    const response = yield call(specialtyProviderDelete, data.payload.id);
    yield put(ScheduleApiResponseSuccess(DELETE_SCHEDULE, response));
    notifySuccess('Visita deletada com sucesso!');
  } catch (error) {
    yield put(ScheduleApiResponseError(DELETE_SCHEDULE, error));
    notifyError('Erro ao deletar visita');
  }
}

export function* watchGetSchedule() {
  yield takeEvery(GET_SCHEDULE, getSchedule);
}

export function* watchGetScheduleById() {
  yield takeEvery(GET_SCHEDULE_BY_ID, getScheduleById);
}

export function* watchCreateSchedule() {
  yield takeEvery(CREATE_SCHEDULE, createSchedule);
}

export function* watchUpdateSchedule() {
  yield takeEvery(UPDATE_SCHEDULE, updateSchedule);
}

export function* watchUpdateScheduleRealized() {
  yield takeEvery(UPDATE_SCHEDULE_REALIZED, updateScheduleRealized);
}

export function* watchDeleteSchedule() {
  yield takeEvery(DELETE_SCHEDULE, deleteSchedule);
}

function* ScheduleSaga() {
  yield all([fork(watchGetSchedule)]);
  yield all([fork(watchGetScheduleById)]);
  yield all([fork(watchCreateSchedule)]);
  yield all([fork(watchUpdateSchedule)]);
  yield all([fork(watchUpdateScheduleRealized)]);
  yield all([fork(watchDeleteSchedule)]);
}

export default ScheduleSaga;
